import { render, staticRenderFns } from "./UpdateCouponPage.vue?vue&type=template&id=39f2a9ea"
import script from "./UpdateCouponPage.vue?vue&type=script&lang=js"
export * from "./UpdateCouponPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports